import React from "react"
import { getIllustration, splitOnMdxType } from "../../utils/mdxTypeUtils"
import style from "./Features.module.scss"

export default ({ children }) => {
  const sections = splitOnMdxType('h2', children)

  return (
    sections.map((section, i) => {
      const { illustration, content, } = getIllustration(section)

      return (
        <section className={style.container} key={i}>
          <aside>
            {illustration}
          </aside>
          <article>
            {content}
          </article>
        </section>
      )
    })
  )
}
